export default "__VITE_ASSET__C33t0B$J__"